<template>
  <div
    :class="{bd_collapse: !showBarList}"
    class="menu_root"
  >
    <pc-only
      class="flex"
      style="height:100%;"
    >
      <!-- search form (Optional) -->
      <!-- <form @submit.prevent="setKeyword(q)" class="pc_only search_ctn flex" v-show="showBarList">
        <input type="text" v-model='q' class="search_input flex1" placeholder="搜索菜单">
        <button type="submit" class="search_btn"><fa-icon icon="search"/></button>
      </form>
      <div class="search_space" v-show="showBarList"></div> -->
      <!-- /.search form -->
      <div class="nav_left">
        <div
          v-if="isShowIcon"
          class="nav_home_box">
          <img
            class="nav_home_icon"
            src="http://img.yimutian.com/crm/66ea34de2d211f498906154700a6005c.png"
            @click="toHome"
          >
        </div>
        <ul class="navlist">
          <li
            v-for="(current, index) in list"
            :key="index"
            :class="{active_nav: firstResourceId == current.resourceId}"
          >
            <div
              :class="{has_child: current.children}"
              class="left_menu flex"
              @click="changeNav(current,index)"
            >
              <div class="menu_icon">
                <img
                  :src="current.resourceUrl | menuIcon('icon')"
                  class="unselected"
                >
                <img
                  :src="current.resourceUrl | menuIcon('selectedIcon')"
                  class="selected"
                >
              </div>
              <span class="nav_name">{{ current.resourceName }}</span>
            </div>
          </li>
        </ul>
      </div>
      <div
        v-if="current && current.children"
        class="nav_right"
      >
        <ul class="navlist">
          <li
            v-for="current in current.children"
            :key="current.resourceId"
            :class="{active: secondResourceId == current.resourceId}"
          >
            <div
              :class="{has_child: current.children.length}"
              class="menu0"
              @click="open(current, current.children)"
            >
              <div class="arrow" />
              <span
                :class="{
                  active: secondResourceId == current.resourceId,
                  paddingLeft24: !current.children.length,
                  selectColor: secondResourceId == current.resourceId && !current.children
                }"
                class="menu0_name"
              >{{ current.resourceName }}</span>
            </div>
            <div
              :style="{height: menu1Height(current, current.children)}"
              class="menu1_ctn"
            >
              <div
                class="menu0"
                @click="open(current, current.children)"
              >
                {{ current.resourceName }}
              </div>
              <div
                v-for="subMenu in current.children"
                :key="subMenu.resourceId"
                :class="{selectColor: thirdResourceId == subMenu.resourceId}"
                class="menu1"
                @click="setParam(subMenu)"
              >
                {{ subMenu.resourceName }}
              </div>
            </div>
          </li>
        </ul>
      </div>
    </pc-only>
    <!-- <phone-only class="layout">
      <div class="showLay" @click="closeMenu">
        <ul class="navlist" :style="{top: showBarList ? '0' : '-100%'}">
          <li v-for="{current, children} in filteredList" :key='current.resourceId' :class="{active: currentResourceId === current.resourceId}">
            <div class="menu0" :class="{has_child: children.length}" @click.stop="open(current, children)">
              <span class="menu0_name">{{current.resourceName}}</span>
              <div class="arrow"></div>
            </div>
            <div class="menu1_ctn" :style="{height: menu1Height(current, children)}">
              <router-link class="menu1" v-for="subMenu in children" :key="subMenu.resourceId" :to="{name: subMenu.resourceUrl}">{{subMenu.resourceName}}</router-link>
            </div>
          </li>
        </ul>
      </div>
    </phone-only> -->
  </div>
</template>
<script>
import { mapGetters, mapState } from 'vuex'
import menuIcon from '@/filters/menu_icon'
export default {
  filters: {
    menuIcon
  },
  data() {
    return {
      q: '',
      keyword: '',
      nav_index: 0,
      memory_nav_index: 0,
      firstResourceId: 0,
      secondResourceId: 0,
      thirdResourceId: 0,
      current: {},
      secondDefautlIndex: 0,
      thirdDefaultIndex: 0
    }
  },
  computed: {
    ...mapState({
      list: state => state.menuList,
      originList: state => state.originMenuList,
      currentResourceId: state => state.currentResourceId,
      showBarList: state => state.showBarList,
      currentResourceUrl: state => state.currentResourceUrl,
      currentResourcePath: state => state.currentResourcePath
    }),
    ...mapGetters({
      isShowIcon:'isVideoManagementPage'
    }),
  },
  watch: {
    currentResourceUrl() {
      setTimeout(() => {
        this.matchCurrentUrl()
      }, 100)
    }
  },
  created() {
    this.$store.dispatch('getMenuList').then(() => {
      this.matchCurrentUrl()
    })
  },
  methods: {
    // 过滤菜单
    setKeyword(q) {
      this.keyword = q
    },
    matchCurrentUrl() {
      let resourceId = Number(this.$route.params.typeId)
      let current = {}
      if (resourceId) {
        current = this.originList.find(item => item.resourceId === resourceId)
      } else {
        // 当路由是和视频管理相关的，默认视频管理tab选中
        if (this.currentResourcePath.includes('videoManagement')) {
          current = this.originList.find(item => item.resourceUrl === 'videoManagement')
        } else {
          current = this.originList.find(item => item.resourceUrl === this.currentResourceUrl)
        }
      }
      if (!current) { return } // 匹配不上，说明不在菜单栏里面
      let stepLen = current.resourceCode.toString().split('.')
      if (stepLen.length === 1) {
        resourceId = current.resourceId
        this.firstResourceId = resourceId
        this.current = this.list.find(item => item.resourceUrl === this.currentResourceUrl)
      } else if (stepLen.length === 2) {
        resourceId = Number(stepLen[0])
        this.firstResourceId = resourceId
        this.secondResourceId = Number(stepLen[1])
        this.current = this.list.find(item => item.resourceId === resourceId)
      } else {
        resourceId = Number(stepLen[0])
        this.firstResourceId = resourceId
        this.secondResourceId = Number(stepLen[1])
        this.thirdResourceId = Number(stepLen[2])
        this.current = this.list.find(item => item.resourceId === resourceId)
      }
      // this.$store.commit('setCurrentResourceId', resourceId)
      if (this.current) {
        if (this.current.children) {
          this.$store.commit('setNavStatus', this.current.children)
        }
        this.$store.commit('setNavName', this.current.resourceName)
      }
    },
    menu1Height(current, children) {
      if (this.showBarList) {
        if (this.secondResourceId === current.resourceId) {
          if (window.uiMode === 'phone_only') {
            return (children.length * 90 / 200) + 'rem'
          } else {
            return children.length * 50 + 'px'
          }
        }
        return '0px'
      } else {
        return 'auto'
      }
    },
    mouseOverOpen(current, children) {
      if (!this.showBarList && this.currentResourceId !== current.resourceId) {
        // this.$store.commit('setCurrentResourceId', current.resourceId)
      }
    },
    open(current, children) {
      if (this.secondResourceId === current.resourceId && children) {
        this.secondResourceId = 0
      } else {
        this.secondResourceId = current.resourceId
      }
      if (!children || !children.length) {
        this.$router.push({ name: current.resourceUrl })
      } else {
        this.$router.push({ name: children[0].resourceUrl, params: { typeId: children[0].resourceId } })
      }
    },
    setParam(current) {
      this.thirdResourceId = current.resourceId
      this.$router.push({ name: current.resourceUrl, params: { typeId: current.resourceId } })
    },
    mouseCloseMenu1() {
      if (!this.showBarList) {
        // this.$store.commit('setCurrentResourceId', null)
      }
    },
    mouserEnter(current, index) {
      // this.$store.commit('setCurrentResourceId', current.resourceId)
      this.$store.commit('setNavStatus', current.children)
      this.$store.commit('setNavName', current.resourceName)
      this.nav_index = index
      this.hover = true
    },
    mouseLeave(current, index) {
      this.nav_index = this.memory_nav_index
    },
    closeMenu() {
      this.$store.commit('hideNavBarList')
    },
    changeNav(current, index) {
      if (current.resourceUrl === this.currentResourceUrl || (current.resourceUrl === 'videoManagement' && this.currentResourceUrl === 'video_home_index')){
        return
      }
      let secondDefautlIndex = this.secondDefautlIndex
      let thirdDefaultIndex = this.thirdDefaultIndex
      this.firstResourceId = current.resourceId
      // this.$store.commit('setCurrentResourceId', current.resourceId)
      this.$store.commit('setNavStatus', current.children)
      this.$store.commit('setNavName', current.resourceName)
      this.current = current
      if (current.resourceUrl === 'supplyList') {
        secondDefautlIndex = 1
      }
      if (current.children) {
        this.secondResourceId = current.children[secondDefautlIndex].resourceId
        if (current.children[secondDefautlIndex].children) {
          this.thirdResourceId = current.children[secondDefautlIndex].children[thirdDefaultIndex].resourceId
          this.$router.push({ name: current.resourceUrl, params: { typeId: this.thirdResourceId } })
        } else {
          this.$router.push({ name: current.resourceUrl })
        }
      } else {
        this.$router.push({ name: current.resourceUrl })
      }
    },
    toPublish() {
      this.$router.push({ name: 'publishSupply' })
    },
    toHome() {
      this.$router.push({ name: 'home' })
    }
  }
}
</script>
<style lang="less" scoped>
@import "../assets/lib.less";
li{
  list-style: none;
}
.arrow {
  display: none;
}
.has_child {
  .arrow {
    display: block;
  }
}
.phone_only {
  .menu_root {
    position: fixed;
    left: 0;
    top: 96/@rem;
    z-index: 1;
    box-sizing: border-box;
    z-index: 1;
    width: 100%;
    height: 100%;
    background: transparent;
    visibility: visible;
    overflow: auto;
    &.bd_collapse{
      width:100%;
      visibility: hidden
    }
    .layout {
      position: relative;
      width: 100%;
      height: 100%;
      background-color: rgba(0, 0, 0, 0.3);
      transition: background-color 0.5s;
      .showLay {
        width: 100%;
        height: 100%;
        background-color: rgba(0, 0, 0, 0.6);
      }
      .navlist {
        position: relative;
        left: 0;
        width: 100%;
        top: -100%;
        margin: 0;
        padding: 0;
        background: #fff;
        transition: top 0.3s;
        max-height: 100%;
        overflow: auto;
        .menu0 {
          font-size: 28/@rem;
          position: relative;
          left: 0;
          top: 0;
          height: 96/@rem;
          line-height: 96/@rem;
          border-bottom: 01/@rem solid #e2e2e2;
          box-sizing: border-box;
          padding-left: 24/@rem;
        }
        .menu0 {
          .arrow {
            position: absolute;
            right: 24/@rem;
            top: 36/@rem;
            width: 16/@rem;
            height: 16/@rem;
            border-right: 1px solid #b7b7b7;
            border-bottom: 1px solid #b7b7b7;
            transform: rotate(-45deg);
          }
        }
        .active {
          .menu0 {
            .arrow {
              transform: rotate(45deg);
            }
          }
        }
        .menu1_ctn {
          height: 0px;
          overflow: hidden;
          transition: height 300ms;
          background-color: #f2f2f2;
        }
        & > li {
          a.menu1 {
            position: relative;
            display: flex;
            width: 100%;
            justify-content: space-between;
            width: 100%;
            padding: 0 48/@rem;
            height: 89/@rem;
            line-height: 89/@rem;
            box-sizing: border-box;
            text-decoration: none;
            color: #333;
            border-bottom: 01/@rem solid #e2e2e2;
            font-size: 24/@rem;
            &:last-child {
              border-bottom: 0 none;
            }

            &::before {
              top: 34/@rem;
              right: 16/@rem;
              border-width: 7px;
              border-left-color: #b7b7b7;
            }
          }
        }
      }
    }
  }
}
.pc_only {
  .menu_root{
    // width: 280px;
    height: 100%;
    // background: #2f4252;
    transition: width 0.3s;
    color: #fff;
    box-sizing: border-box;
    font-size: 14px;
    color: #95a4b1;
    overflow: auto;
    &.bd_collapse {
      width: 50px;
      overflow: visible;
    }
    .nav_left{
      width: 130px;
      height:100%;
      // font-family: PingFang-SC-Medium;
      font-size: 16px;
      color: #FFFFFF;
      .nav_home_box {
        width: 100%;
        height: 60px;
        display: flex;
        justify-content: center;
        align-items: center;
        .nav_home_icon {
          width: 83px;
          height: 46px;
        }
      }
      .left_menu{
        flex-direction: column;
        align-items: center;
        justify-content: center;
        height:80px;
        &hover{
          background:#ffffff;
          color:#000000;
        }
      }
      .active_nav{
        .left_menu{
          background:#ffffff;
          color:#000000;
        }
        .menu_icon > img.unselected {
          transform: translateX(-100%);
        }
        .menu_icon > img.selected {
          transform: translateX(0);
        }
      }
      .menu0_name{
        color:#ffffff;
      }
      background: #1B1B1C;
    }
    .nav_right{
      width:150px;
      background: #ffffff;
      height:100%;
      line-height: 50px;
    }
  }
  .search_ctn {
    border-radius: 3px;
    margin: 10px;
    position: relative;
    left: 0;
    top: 0;
    background-color: #374850;
    height: 34px;
    line-height: 34px;
    color: #666;
    overflow: hidden;
  }
  .search_input {
    border-radius: 2px;
    border-top-right-radius: 0;
    border-bottom-right-radius: 0;
    box-shadow: none;
    background-color: #374850;
    border: none;
    height: 34px;
    padding: 0 12px;
    transition: all 0.3s ease-in-out;
    &:focus {
      background-color: #fff;
    }
    &:focus + .search_btn {
      background-color: #fff;
    }
  }
  .search_btn {
    width: 34px;
    height: 34px;
    padding: 0;
    margin: 0;
    border: none;
    background: transparent;
    color: #666;
    transition: all 0.3s ease-in-out;
    cursor: pointer;
  }
  .search_space {
    bottom: 0;
    width: 100%;
    height: 20px;
    background-color: #1a2226;
  }
  .bd_collapse {
    .menu0_name {
      display: none;
    }
    .arrow {
      display: none;
    }
    .menu1_ctn {
      display: none;
      .menu1 {
        padding-left: 18px;
      }
    }
    .active {
      position: relative;
      left: 0;
      top: 0;
      .menu1_ctn {
        display: block;
        width: 200px;
        position: absolute;
        top: 0px;
        left: 50px;
        z-index: 2;
        border-top-right-radius: 4px;
        border-bottom-right-radius: 4px;
        .menu0 {
          display: block;
        }
      }
    }
  }
  .navlist {
    padding: 0;
    margin: 0;
    li {
      padding: 0;
      cursor: pointer;
    }
    a {
      font-size: 14px;
      color: #333333;
      text-decoration: none;
    }
    .active {
      .menu0 {
        // background-color: #253746;
        .arrow {
          float: left;
          // border-right: 1px solid #fff;
          // border-bottom: 1px solid #fff;
          transform: rotate(45deg);
        }
        a {
          color: #333333;
        }
        color: #333333;
      }
      .menu_icon > img.unselected {
        transform: translateX(-100%);
      }
      .menu_icon > img.selected {
        transform: translateX(0);
      }
      .menu1 {
        // &:hover {
        //   color: #00AC8B;
        // }
        // a:hover {
        //   color: #00AC8B;
        // }
      }
    }
    .menu0 {
      &:hover {
        // background-color: #253746;
      }
      white-space: nowrap;
      padding-left: 18px;
      // background-color: #2f4252;
      color:#333333;
      transition: color 300ms;
      .arrow {
        width: 6px;
        height: 6px;
        float: left;
        margin-top: 18px;
        margin-right: 18px;
        transform-origin: 50% 50%;
        border-right: 1px solid #95a4b1;
        border-bottom: 1px solid #95a4b1;
        transform: rotate(-45deg);
        transition: transform 300ms;
      }
    }
    .menu_icon {
      width: 16px;
      height: 16px;
      overflow: hidden;
      position: relative;
      left: 0;
      top: 0;
      background-size: cover;
      display: inline-block;
      vertical-align: text-bottom;
      margin-right: 6px;
      > img {
        &.selected {
          transform: translateX(-100%);
        }
        &.unselected {
          transform: translateX(0);
        }
        position: absolute;
        top: 0;
        max-width: 100%;
        max-height: 100%;
      }
    }
    .menu1_ctn {
      height: 0px;
      overflow: hidden;
      transition: height 300ms;
      .menu0 {
        display: none;
      }
    }
    .menu1 {
      display: block;
      white-space: nowrap;
      // background: #293c4b;
      padding-left: 42px;
    }
    .paddingLeft24{
      padding-left: 24px;
    }
    .selectColor{
      color:#00AC8B;
    }
  }
}
</style>
